import React from 'react'
import { Snackbar, IconButton, SnackbarContent } from '@mui/material'
import { Close as CloseIcon } from '@mui/icons-material'
import { styled } from '@mui/system'

const getColorBySeverity = (severity) => {
	switch (severity) {
		case 'success':
			return '#4caf50' // Green for success
		case 'error':
			return '#f44336' // Red for error
		case 'warning':
			return '#ff9800' // Orange for warning
		case 'info':
		default:
			return '#2196f3' // Blue for info
	}
}

const CustomToastContent = styled(SnackbarContent)(({ severity }) => {
	const backgroundColor = getColorBySeverity(severity)
	return {
		backgroundColor,
		color: '#ffffff', // White text color
		borderRadius: 4,
		padding: '8px 8px',
		display: 'flex',
		alignItems: 'center',
		maxWidth: '100vw', // Limit width to 80% of viewport width
		wordBreak: 'break-word', // Ensure long words don't overflow
	}
})

const CenteredSnackbar = styled(Snackbar)({
	position: 'fixed',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	minWidth: '260px',
	// maxWidth: '100%', // Ensure it doesn't exceed screen width
	// maxHeight: '100%', // Ensure it doesn't exceed screen height
})

const CustomToast = ({ open, message, severity = 'info', onClose }) => (
	<CenteredSnackbar open={open} autoHideDuration={7000} onClose={onClose} anchorOrigin={{ vertical: 'center', horizontal: 'center' }}>
		<CustomToastContent
			severity={severity}
			message={<span style={{ flex: 1, overflowWrap: 'break-word' }}>{message}</span>}
			action={
				<IconButton size='small' aria-label='close' color='inherit' onClick={onClose}>
					<CloseIcon fontSize='small' />
				</IconButton>
			}
		/>
	</CenteredSnackbar>
)

export default CustomToast
